export enum CacheName {
  ExternalAPIs = 'external-APIs',
  ImagesFontsAndScripts = 'images-fonts-and-scripts',
  GoogleFontsStylesheets = 'google-fonts-stylesheets',
  QuickGO = 'quickGO',
  ProteinsAPI = 'proteins-api',
  WebsiteAPI = 'website-api',
  WebsiteAPIStatic = 'website-api-static',
  WebsiteAPITextContent = 'website-api-text-content',
}
